import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, BASE_URL, colors } from "../shared/constants";
import { fieldStyle, labelStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function InspectionReassignModal({ inspection, onClose, onSave }) {
  const [technicians, setTechnicians] = useState([]);
  const [assignedTo, setAssignedTo] = useState(
    inspection.assigned_to ? String(inspection.assigned_to) : ""
  );
  const [additionalTechs, setAdditionalTechs] = useState(
    (inspection.additional_techs || []).map(String)
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${BASE_URL}/auth/technicians/`).then((res) => setTechnicians(res.data)).catch(() => {});
  }, []);

  const toggleTech = (id) => {
    const idStr = String(id);
    if (assignedTo === idStr) {
      if (additionalTechs.length > 0) {
        setAssignedTo(additionalTechs[0]);
        setAdditionalTechs(additionalTechs.slice(1));
      } else {
        setAssignedTo("");
      }
    } else if (additionalTechs.includes(idStr)) {
      setAdditionalTechs(additionalTechs.filter((t) => t !== idStr));
    } else if (!assignedTo) {
      setAssignedTo(idStr);
    } else {
      setAdditionalTechs([...additionalTechs, idStr]);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      const leadTech = technicians.find((t) => String(t.id) === assignedTo);
      const leadName = leadTech
        ? (leadTech.first_name && leadTech.last_name ? `${leadTech.first_name} ${leadTech.last_name}` : leadTech.username)
        : null;
      await axios.patch(`${API}/inspections/${inspection.id}/`, {
        assigned_to: assignedTo ? Number(assignedTo) : null,
        additional_techs: additionalTechs.map(Number),
        ...(leadName ? { inspector_name: leadName } : {}),
      });
      onSave();
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.[0] || "Something went wrong.");
      setSaving(false);
    }
  };

  return (
    <SimpleModal
      title={`Assign — ${inspection.site_name}${inspection.site_area_name ? ` / ${inspection.site_area_name}` : ""}`}
      onClose={onClose}
      onSave={handleSave}
      saving={saving}
      error={error}
    >
      <div style={fieldStyle}>
        <label style={labelStyle}>Technicians</label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {technicians.map((tech) => {
            const idStr = String(tech.id);
            const name = tech.first_name && tech.last_name
              ? `${tech.first_name} ${tech.last_name}`
              : tech.username;
            const isLead = assignedTo === idStr;
            const isAdditional = additionalTechs.includes(idStr);
            const selected = isLead || isAdditional;
            return (
              <button
                key={tech.id}
                type="button"
                onClick={() => toggleTech(tech.id)}
                style={{
                  padding: "6px 14px",
                  borderRadius: "20px",
                  border: `2px solid ${selected ? (isLead ? colors.teal : colors.amber) : colors.border}`,
                  backgroundColor: selected ? (isLead ? "#e0f2fe" : "#fef3c7") : "white",
                  color: selected ? (isLead ? colors.teal : "#92400e") : colors.slate,
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                {name}{isLead ? " · Lead" : isAdditional ? " · + Tech" : ""}
              </button>
            );
          })}
        </div>
        <div style={{ fontSize: "11px", color: colors.slate, marginTop: "6px" }}>
          First selected = Lead tech. Tap again to remove.
        </div>
      </div>
    </SimpleModal>
  );
}
